import React, { Component } from "react";
import { Modal, ControlLabel, FormControl, Button } from "react-bootstrap";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { getRecipientFriendListSuperAdmin } from "./MemberManagementHelper";
import { customLog } from "../../variables/Variables";
import { fire, auth } from "../../firebase/index";
import LocalizedStrings from "react-localization";
import "../../assets/css/groupmanagement.css";
import { style, emailRegex } from "variables/Variables.jsx";
import { FormGroup } from "semantic-ui-react";

//import localization
//Localization codes
let localizationStrings = new LocalizedStrings({
  en: {
    userInfoTitle: "Add Recipient To Member",
    serialNoTitle: "Serial No.",
    lockNameTitle: "Lock Name",
    showInfoButton: "Add Recipient",
    loadingText: "loading...",
    noLocksText: "No locks found",
    noRecipientsText: "No Member Recipients found",
    recipientHeader: "Recipients",
    lockHeader: "Locks",
    recipientEmailTitle: "Receipient Email",
    recipientNameTitle: "Receipient Name",
    Recipients: "Member Recipient List",
    selectedMembersHeader: "Selected Members List",
    emailHeader: "Member Email",
    cancelTitle: "Cancel",
    createTitle: "Create",
    blank: "",
  },
  ja: {
    userInfoTitle: "メンバー詳細",
    serialNoTitle: "シリアルナンバー",
    lockNameTitle: "ロック名称",
    showInfoButton: "情報を表示",
    loadingText: "loading...",
    noLocksText: "ロックのデータがありません。",
    noRecipientsText: "メンバー受取人が見つかりません",
    recipientHeader: "共有先リスト",
    lockHeader: "スマートロック",
    recipientEmailTitle: "共有者メールアドレス",
    recipientNameTitle: "共有者名",
    Recipients: "メンバー受取人リスト",
    selectedMembersHeader: "選択されたメンバーリスト",
    emailHeader: "メンバーのメール",
    cancelTitle: "キャンセル",
    createTitle: "作成",
    blank: "",
  },
  es: {
    userInfoTitle: "Agregar Destinatario a Miembro",
    serialNoTitle: "Número de Serie",
    lockNameTitle: "Nombre de la Candado",
    showInfoButton: "Agregar Destinatario",
    loadingText: "loading...",
    noLocksText: "No se encontraron candados",
    noRecipientsText: "No se encontraron destinatarios de miembros",
    recipientHeader: "Destinatarios",
    lockHeader: "Candados",
    recipientEmailTitle: "Correo Electrónico del Destinatario",
    recipientNameTitle: "Nombre del Destinatario",
    Recipients: "Lista de Destinatarios de Miembros",
    selectedMembersHeader: "Lista de Miembros Seleccionados",
    emailHeader: "Correo Electrónico del Miembro",
    cancelTitle: "Cancelar",
    createTitle: "Crear",
    blank: "",
  },
});

export class AddRecipient extends Component {
  constructor(props) {
    super(props);

    this.showInfoClicked = this.showInfoClicked.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.customConfirmDialog = this.customConfirmDialog.bind(this);
    this.renderSelectMember = this.renderSelectMember.bind(this);
    this.unselectMember = this.unselectMember.bind(this);
    this.onSubmit = this.onSubmit.bind(this);

    const cell = this.props.cellValue;
    const row = this.props.rowValue;

    this.state = {
      cell: cell,
      row: row,
      userLocks: [],
      noDataText: localizationStrings.loadingText,
      noDataTextRecipient: localizationStrings.loadingText,
      showPopup: false,
      loading: false,
      selectedmemberRecipientList: [],
    };
  }

  componentWillMount() {
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid) // get uid from auth person object
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            currentLanguage: snapshot.val(),
          });
        });
    }
  }

  async showInfoClicked() {
    this.setState({ showPopup: true });
    customLog(this.state.cell);
    customLog(this.state.row);

    const selectedmemberRecipientList = this.state.selectedmemberRecipientList;
    const { memberEmail } = this.props; // Assuming the parent component passes memberEmail and userId as props

    const {
      membersInsideGroup,
      userId,
    } = await getRecipientFriendListSuperAdmin(memberEmail);

    this.setState({
      memberRecipientList: membersInsideGroup,
      userId: userId,
    });

    if (membersInsideGroup.length <= 0) {
      this.setState({
        noDataTextRecipient: localizationStrings.noRecipientsText,
      });
    } else if (selectedmemberRecipientList.length >= 0) {
      this.setState({
        noDataTextRecipient: localizationStrings.blank,
      });
    }
  }

  renderSelectMember(cell, row) {
    return (
      <div>
        <button
          className={"select-btn"}
          onClick={(e) => {
            e.preventDefault();

            const lockListArrayList = this.state.memberRecipientList;
            const selectedLockGroupList = this.state
              .selectedmemberRecipientList;

            lockListArrayList.splice(lockListArrayList.indexOf(row), 1);
            selectedLockGroupList.push(row);

            this.setState({
              memberRecipientList: lockListArrayList,
              selectedmemberRecipientList: selectedLockGroupList,
            });
          }}
        >
          <span className="plusIcon">&#43;</span>
        </button>
      </div>
    );
  }

  unselectMember(cell, row) {
    return (
      <div>
        <button
          className={"unselect-btn"}
          onClick={(e) => {
            e.preventDefault();

            const lockListArrayList = this.state.memberRecipientList;
            const selectedLockGroupList = this.state
              .selectedmemberRecipientList;

            lockListArrayList.push(row);
            selectedLockGroupList.splice(selectedLockGroupList.indexOf(row), 1);

            this.setState({
              memberRecipientList: lockListArrayList,
              selectedmemberRecipientList: selectedLockGroupList,
            });
          }}
        >
          <span className="crossIcon">&times;</span>
        </button>
      </div>
    );
  }

  async onSubmit() {
    const userId = this.state.userId;
    const emailToAdd = this.state.selectedmemberRecipientList;
    // console.log(this.state.selectedmemberRecipientList);
    // console.log(this.state.selectedmemberRecipientList.length);

    customLog(emailToAdd.length);
    let successCounter = 0; // Counter for successful database updates

    for (let i = 0; i < emailToAdd.length; i++) {
      let email = emailToAdd[i].memberEmail;
      const nameSplit = email.split("@");
      const formattedName = nameSplit[0].replace(/\./g, "_");
      let name = formattedName;
      customLog(name);

      const nameregexOnlySpace = /^[" "]+$/i; // For name: contain only spacing
      let errMsg = "";
      const userFriendListDB = fire.database().ref("userFriendList");
      const userFriendListIndustrialDB = fire
        .database()
        .ref("userFriendListIndustrial");
      const groupAccountDB = fire.database().ref("groupAccounts");
      let existInGroupAccount = false;
      let existInUserFriendList = false;
      let existInUserFriendListIndustrial = false; //don't delete

      let nameData, emailData;

      //! Check if user exists in the groupAccounts
      await groupAccountDB.once("value").then((snapshot) => {
        snapshot.forEach((superAdminDetails) => {
          const detailsVal = superAdminDetails.val();
          const members = detailsVal.members;
          for (const eachMember in members) {
            const memberDetails = members[eachMember];
            if (memberDetails.memberEmail === auth.currentUser.email) {
              for (const membersUnderSameAdmin in members) {
                if (members[membersUnderSameAdmin].memberEmail === email) {
                  existInGroupAccount = true;
                }
              }
            }
          }
        });
      });

      await userFriendListIndustrialDB
        .child(userId)
        .once("value")
        .then((snapshot) => {
          if (snapshot.exists()) {
            const snapshotVal = snapshot.val();
            for (const eachFriend in snapshotVal) {
              if (snapshotVal[eachFriend].friendEmail === email) {
                existInUserFriendListIndustrial = true;
              }
            }
          }
          // console.log(userId);
        });

      let emailValid = emailRegex.test(email);
      if (!nameregexOnlySpace.test(name)) {
        if (nameData !== name && emailData !== email) {
          if (existInGroupAccount) {
            if (!existInUserFriendListIndustrial) {
              if (emailValid) {
                await this.updateDatabase(name, email);
                successCounter++; // Increment the counter after a successful update
                // console.log(successCounter);

                if (
                  successCounter ===
                  this.state.selectedmemberRecipientList.length
                ) {
                  // Check if all updates are done
                  window.location.reload(); // Refresh the page
                  // console.log(successCounter);
                }
              } else {
                // ...handle email validation error...
              }
            } else {
              // ...handle user already exists in userFriendListIndustrial...
            }
          } else {
            // ...handle user not found in groupAccountDB...
          }
        } else {
          // ...handle duplicate name or email...
        }
      } else {
        // ...handle name containing only spaces...
      }
    }
  }

  async updateDatabase(name, email) {
    return new Promise(async (resolve, reject) => {
      const currentUserID = this.state.userId;
      const userFriendListDB = fire.database().ref("userFriendList");
      const userFriendListIndustrialDB = fire
        .database()
        .ref("userFriendListIndustrial");
      const registeredUsersOnPlatformDB = fire
        .database()
        .ref("registeredUsersOnPlatform");
      const historicalRecipientsDB = fire
        .database()
        .ref("historicalRecipients");

      try {
        const snapshot = await registeredUsersOnPlatformDB
          .orderByValue()
          .once("value");
        if (email !== snapshot.val()) {
          let friendListKey = await userFriendListIndustrialDB
            .child(currentUserID)
            .push().key;

          const industrialRecipientDetails = {
            allowAccess: true,
            friendEmail: email,
            friendName: name,
            id: friendListKey,
          };

          await userFriendListIndustrialDB
            .child(currentUserID)
            .child(friendListKey)
            .set(industrialRecipientDetails);

          let historicalKey = await historicalRecipientsDB
            .child(currentUserID)
            .push().key;

          const recipientDetails = {
            dateTimeAdded: new Date() / 1000,
            email: email,
            name: name,
            id: historicalKey,
          };

          await historicalRecipientsDB
            .child(currentUserID)
            .child(historicalKey)
            .set(recipientDetails);
        }

        resolve(); // Resolve the promise after successful update
      } catch (error) {
        reject(error); // Reject the promise if there's an error
      }
    });
  }

  handleClose() {
    this.setState({
      showPopup: false,
      memberRecipientList: [],
      selectedmemberRecipientList: [],
    });
  }

  customConfirmDialog(next) {
    next();
  }

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    //! FOR LANGUAGE SETTING
    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage === "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage === "es") {
      localizationStrings.setLanguage("es");
    }

    const columnHover = (cell, row, enumObject, rowIndex) => {
      return cell;
    };

    return (
      <div>
        <Modal
          show={this.state.showPopup}
          onHide={this.handleClose}
          dialogClassName="modal-70w"
        >
          <Modal.Header closeButton>
            <Modal.Title>{localizationStrings.userInfoTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ padding: "30px 30px 40px 30px" }}>
            <form>
              <ControlLabel style={{ fontSize: "1.2em" }}>
                {localizationStrings.Recipients}
              </ControlLabel>
              {/* SELECT TABLE FOR GROUP */}
              <div className="selectMembersTable">
                <BootstrapTable
                  data={this.state.memberRecipientList}
                  bordered={false}
                  pagination
                  options={{
                    sizePerPage: 5,
                    hideSizePerPage: true,
                    defaultSortOrder: "asc", // default sort order
                    noDataText: this.state.noDataTextRecipient,
                  }}
                >
                  <TableHeaderColumn
                    dataField="memberName"
                    tdStyle={{ textAlign: "center" }}
                    thStyle={{ textAlign: "center" }}
                    hidden
                  >
                    {localizationStrings.nameHeader}
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="memberEmail"
                    isKey={true}
                    tdStyle={{ textAlign: "center" }}
                    thStyle={{ textAlign: "center" }}
                  >
                    {localizationStrings.emailHeader}
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataFormat={this.renderSelectMember}
                    tdStyle={{ textAlign: "center" }}
                    thStyle={{ textAlign: "center" }}
                  ></TableHeaderColumn>
                </BootstrapTable>
                <ControlLabel style={{ fontSize: "1.2em" }}>
                  {localizationStrings.selectedMembersHeader}
                </ControlLabel>
                <BootstrapTable
                  data={this.state.selectedmemberRecipientList}
                  bordered={false}
                  pagination
                  options={{
                    sizePerPage: 5,
                    hideSizePerPage: true,
                    defaultSortOrder: "asc", // default sort order
                    // noDataText: this.state.noDataTextRecipient
                    noDataText: localizationStrings.noRecipientsText,
                  }}
                >
                  <TableHeaderColumn
                    dataField="memberName"
                    tdStyle={{ textAlign: "center" }}
                    thStyle={{ textAlign: "center" }}
                    hidden
                  >
                    {localizationStrings.nameHeader}
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="memberEmail"
                    isKey={true}
                    tdStyle={{ textAlign: "center" }}
                    thStyle={{ textAlign: "center" }}
                  >
                    {localizationStrings.emailHeader}
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataFormat={this.unselectMember}
                    tdStyle={{ textAlign: "center" }}
                    thStyle={{ textAlign: "center" }}
                  ></TableHeaderColumn>
                </BootstrapTable>
              </div>
              <FormGroup style={{ display: "flex" }}>
                <Button style={{ marginRight: "10px" }} onClick={this.onSubmit}>
                  {localizationStrings.createTitle}
                </Button>
                <Button
                  style={{ marginLeft: "10px" }}
                  onClick={this.handleClose}
                >
                  {localizationStrings.cancelTitle}
                </Button>
              </FormGroup>
            </form>
          </Modal.Body>
        </Modal>
        <Button
          onClick={this.showInfoClicked}
          className="btn btn-info"
          style={{ borderRadius: "50px" }}
        >
          {localizationStrings.showInfoButton}
        </Button>
      </div>
    );
  }
}

export default AddRecipient;
